export default __webpack_public_path__ + "static/media/salada-de-frutas.3ec1aebd.jpg";